// Token counting utility
export const countTokens = (text) => {
  if (!text) return 0;
  // This is a simple approximation - for production, use a proper tokenizer
  return Math.ceil(text.split(/[\s,.-?!]+/).length * 1.3);
};
